import {Loc} from 'landing.loc';

export const SimpleLinePro2 = {
	id: 'simple_line_icon_pro_2',
	name: 'Simple Line Icon Pro 2',
	active: true,
	categories: [
		{
			id: 'CHRISTMAS',
			name: Loc.getMessage('LANDING_ICONS_SECTION_CHRISTMAS'),
			items: [
				'u-line-icon-pro icon-christmas-001',
				'u-line-icon-pro icon-christmas-014',
				'u-line-icon-pro icon-christmas-015',
				'u-line-icon-pro icon-christmas-002',
				'u-line-icon-pro icon-christmas-003',
				'u-line-icon-pro icon-christmas-016',
				'u-line-icon-pro icon-christmas-017',
				'u-line-icon-pro icon-christmas-004',
				'u-line-icon-pro icon-christmas-005',
				'u-line-icon-pro icon-christmas-018',
				'u-line-icon-pro icon-christmas-019',
				'u-line-icon-pro icon-christmas-006',
				'u-line-icon-pro icon-christmas-007',
				'u-line-icon-pro icon-christmas-020',
				'u-line-icon-pro icon-christmas-021',
				'u-line-icon-pro icon-christmas-008',
				'u-line-icon-pro icon-christmas-009',
				'u-line-icon-pro icon-christmas-009',
				'u-line-icon-pro icon-christmas-022',
				'u-line-icon-pro icon-christmas-023',
				'u-line-icon-pro icon-christmas-010',
				'u-line-icon-pro icon-christmas-011',
				'u-line-icon-pro icon-christmas-024',
				'u-line-icon-pro icon-christmas-025',
				'u-line-icon-pro icon-christmas-012',
				'u-line-icon-pro icon-christmas-013',
				'u-line-icon-pro icon-christmas-026',
				'u-line-icon-pro icon-christmas-039',
				'u-line-icon-pro icon-christmas-038',
				'u-line-icon-pro icon-christmas-051',
				'u-line-icon-pro icon-christmas-052',
				'u-line-icon-pro icon-christmas-065',
				'u-line-icon-pro icon-christmas-064',
				'u-line-icon-pro icon-christmas-063',
				'u-line-icon-pro icon-christmas-050',
				'u-line-icon-pro icon-christmas-037',
				'u-line-icon-pro icon-christmas-036',
				'u-line-icon-pro icon-christmas-049',
				'u-line-icon-pro icon-christmas-062',
				'u-line-icon-pro icon-christmas-061',
				'u-line-icon-pro icon-christmas-048',
				'u-line-icon-pro icon-christmas-035',
				'u-line-icon-pro icon-christmas-034',
				'u-line-icon-pro icon-christmas-047',
				'u-line-icon-pro icon-christmas-060',
				'u-line-icon-pro icon-christmas-059',
				'u-line-icon-pro icon-christmas-046',
				'u-line-icon-pro icon-christmas-033',
				'u-line-icon-pro icon-christmas-032',
				'u-line-icon-pro icon-christmas-045',
				'u-line-icon-pro icon-christmas-058',
				'u-line-icon-pro icon-christmas-031',
				'u-line-icon-pro icon-christmas-044',
				'u-line-icon-pro icon-christmas-057',
				'u-line-icon-pro icon-christmas-056',
				'u-line-icon-pro icon-christmas-043',
				'u-line-icon-pro icon-christmas-030',
				'u-line-icon-pro icon-christmas-029',
				'u-line-icon-pro icon-christmas-042',
				'u-line-icon-pro icon-christmas-055',
				'u-line-icon-pro icon-christmas-054',
				'u-line-icon-pro icon-christmas-041',
				'u-line-icon-pro icon-christmas-028',
				'u-line-icon-pro icon-christmas-027',
				'u-line-icon-pro icon-christmas-040',
				'u-line-icon-pro icon-christmas-053',
				'u-line-icon-pro icon-christmas-066',
				'u-line-icon-pro icon-christmas-079',
				'u-line-icon-pro icon-christmas-092',
				'u-line-icon-pro icon-christmas-093',
				'u-line-icon-pro icon-christmas-080',
				'u-line-icon-pro icon-christmas-067',
				'u-line-icon-pro icon-christmas-068',
				'u-line-icon-pro icon-christmas-081',
				'u-line-icon-pro icon-christmas-094',
				'u-line-icon-pro icon-christmas-095',
				'u-line-icon-pro icon-christmas-082',
				'u-line-icon-pro icon-christmas-069',
				'u-line-icon-pro icon-christmas-070',
				'u-line-icon-pro icon-christmas-083',
				'u-line-icon-pro icon-christmas-096',
				'u-line-icon-pro icon-christmas-097',
				'u-line-icon-pro icon-christmas-084',
				'u-line-icon-pro icon-christmas-071',
				'u-line-icon-pro icon-christmas-072',
				'u-line-icon-pro icon-christmas-085',
				'u-line-icon-pro icon-christmas-098',
				'u-line-icon-pro icon-christmas-099',
				'u-line-icon-pro icon-christmas-086',
				'u-line-icon-pro icon-christmas-073',
				'u-line-icon-pro icon-christmas-074',
				'u-line-icon-pro icon-christmas-087',
				'u-line-icon-pro icon-christmas-100',
				'u-line-icon-pro icon-christmas-088',
				'u-line-icon-pro icon-christmas-075',
				'u-line-icon-pro icon-christmas-076',
				'u-line-icon-pro icon-christmas-089',
				'u-line-icon-pro icon-christmas-090',
				'u-line-icon-pro icon-christmas-077',
				'u-line-icon-pro icon-christmas-078',
				'u-line-icon-pro icon-christmas-091',
			],
		},
		{
			id: 'COMMUNICATION',
			name: Loc.getMessage('LANDING_ICONS_SECTION_COMMUNICATION'),
			items: [
				'u-line-icon-pro icon-communication-001',
				'u-line-icon-pro icon-communication-002',
				'u-line-icon-pro icon-communication-003',
				'u-line-icon-pro icon-communication-004',
				'u-line-icon-pro icon-communication-005',
				'u-line-icon-pro icon-communication-006',
				'u-line-icon-pro icon-communication-008',
				'u-line-icon-pro icon-communication-007',
				'u-line-icon-pro icon-communication-009',
				'u-line-icon-pro icon-communication-010',
				'u-line-icon-pro icon-communication-011',
				'u-line-icon-pro icon-communication-012',
				'u-line-icon-pro icon-communication-013',
				'u-line-icon-pro icon-communication-026',
				'u-line-icon-pro icon-communication-025',
				'u-line-icon-pro icon-communication-024',
				'u-line-icon-pro icon-communication-023',
				'u-line-icon-pro icon-communication-022',
				'u-line-icon-pro icon-communication-020',
				'u-line-icon-pro icon-communication-019',
				'u-line-icon-pro icon-communication-018',
				'u-line-icon-pro icon-communication-016',
				'u-line-icon-pro icon-communication-015',
				'u-line-icon-pro icon-communication-014',
				'u-line-icon-pro icon-communication-021',
				'u-line-icon-pro icon-communication-017',
				'u-line-icon-pro icon-communication-027',
				'u-line-icon-pro icon-communication-040',
				'u-line-icon-pro icon-communication-053',
				'u-line-icon-pro icon-communication-054',
				'u-line-icon-pro icon-communication-041',
				'u-line-icon-pro icon-communication-028',
				'u-line-icon-pro icon-communication-029',
				'u-line-icon-pro icon-communication-042',
				'u-line-icon-pro icon-communication-055',
				'u-line-icon-pro icon-communication-056',
				'u-line-icon-pro icon-communication-043',
				'u-line-icon-pro icon-communication-030',
				'u-line-icon-pro icon-communication-031',
				'u-line-icon-pro icon-communication-044',
				'u-line-icon-pro icon-communication-057',
				'u-line-icon-pro icon-communication-058',
				'u-line-icon-pro icon-communication-045',
				'u-line-icon-pro icon-communication-032',
				'u-line-icon-pro icon-communication-033',
				'u-line-icon-pro icon-communication-046',
				'u-line-icon-pro icon-communication-059',
				'u-line-icon-pro icon-communication-060',
				'u-line-icon-pro icon-communication-047',
				'u-line-icon-pro icon-communication-034',
				'u-line-icon-pro icon-communication-035',
				'u-line-icon-pro icon-communication-048',
				'u-line-icon-pro icon-communication-061',
				'u-line-icon-pro icon-communication-062',
				'u-line-icon-pro icon-communication-049',
				'u-line-icon-pro icon-communication-036',
				'u-line-icon-pro icon-communication-037',
				'u-line-icon-pro icon-communication-050',
				'u-line-icon-pro icon-communication-063',
				'u-line-icon-pro icon-communication-064',
				'u-line-icon-pro icon-communication-051',
				'u-line-icon-pro icon-communication-038',
				'u-line-icon-pro icon-communication-039',
				'u-line-icon-pro icon-communication-052',
				'u-line-icon-pro icon-communication-065',
				'u-line-icon-pro icon-communication-066',
				'u-line-icon-pro icon-communication-079',
				'u-line-icon-pro icon-communication-092',
				'u-line-icon-pro icon-communication-105',
				'u-line-icon-pro icon-communication-106',
				'u-line-icon-pro icon-communication-093',
				'u-line-icon-pro icon-communication-080',
				'u-line-icon-pro icon-communication-067',
				'u-line-icon-pro icon-communication-068',
				'u-line-icon-pro icon-communication-081',
				'u-line-icon-pro icon-communication-082',
				'u-line-icon-pro icon-communication-069',
				'u-line-icon-pro icon-communication-070',
				'u-line-icon-pro icon-communication-083',
				'u-line-icon-pro icon-communication-084',
				'u-line-icon-pro icon-communication-071',
				'u-line-icon-pro icon-communication-072',
				'u-line-icon-pro icon-communication-085',
				'u-line-icon-pro icon-communication-086',
				'u-line-icon-pro icon-communication-073',
				'u-line-icon-pro icon-communication-074',
				'u-line-icon-pro icon-communication-087',
				'u-line-icon-pro icon-communication-088',
				'u-line-icon-pro icon-communication-075',
				'u-line-icon-pro icon-communication-076',
				'u-line-icon-pro icon-communication-089',
				'u-line-icon-pro icon-communication-090',
				'u-line-icon-pro icon-communication-077',
				'u-line-icon-pro icon-communication-078',
				'u-line-icon-pro icon-communication-091',
				'u-line-icon-pro icon-communication-104',
				'u-line-icon-pro icon-communication-117',
				'u-line-icon-pro icon-communication-116',
				'u-line-icon-pro icon-communication-103',
				'u-line-icon-pro icon-communication-102',
				'u-line-icon-pro icon-communication-115',
				'u-line-icon-pro icon-communication-114',
				'u-line-icon-pro icon-communication-101',
				'u-line-icon-pro icon-communication-100',
				'u-line-icon-pro icon-communication-113',
				'u-line-icon-pro icon-communication-112',
				'u-line-icon-pro icon-communication-099',
				'u-line-icon-pro icon-communication-098',
				'u-line-icon-pro icon-communication-111',
				'u-line-icon-pro icon-communication-110',
				'u-line-icon-pro icon-communication-097',
				'u-line-icon-pro icon-communication-096',
				'u-line-icon-pro icon-communication-109',
				'u-line-icon-pro icon-communication-108',
				'u-line-icon-pro icon-communication-095',
				'u-line-icon-pro icon-communication-094',
				'u-line-icon-pro icon-communication-107',
				'u-line-icon-pro icon-communication-118',
				'u-line-icon-pro icon-communication-131',
				'u-line-icon-pro icon-communication-144',
				'u-line-icon-pro icon-communication-157',
				'u-line-icon-pro icon-communication-170',
				'u-line-icon-pro icon-communication-171',
				'u-line-icon-pro icon-communication-158',
				'u-line-icon-pro icon-communication-145',
				'u-line-icon-pro icon-communication-132',
				'u-line-icon-pro icon-communication-119',
				'u-line-icon-pro icon-communication-120',
				'u-line-icon-pro icon-communication-133',
				'u-line-icon-pro icon-communication-146',
				'u-line-icon-pro icon-communication-159',
				'u-line-icon-pro icon-communication-172',
				'u-line-icon-pro icon-communication-173',
				'u-line-icon-pro icon-communication-160',
				'u-line-icon-pro icon-communication-147',
				'u-line-icon-pro icon-communication-134',
				'u-line-icon-pro icon-communication-121',
				'u-line-icon-pro icon-communication-122',
				'u-line-icon-pro icon-communication-135',
				'u-line-icon-pro icon-communication-148',
				'u-line-icon-pro icon-communication-161',
				'u-line-icon-pro icon-communication-174',
				'u-line-icon-pro icon-communication-175',
				'u-line-icon-pro icon-communication-162',
				'u-line-icon-pro icon-communication-149',
				'u-line-icon-pro icon-communication-136',
				'u-line-icon-pro icon-communication-123',
				'u-line-icon-pro icon-communication-124',
				'u-line-icon-pro icon-communication-137',
				'u-line-icon-pro icon-communication-150',
				'u-line-icon-pro icon-communication-163',
				'u-line-icon-pro icon-communication-176',
				'u-line-icon-pro icon-communication-177',
				'u-line-icon-pro icon-communication-164',
				'u-line-icon-pro icon-communication-151',
				'u-line-icon-pro icon-communication-138',
				'u-line-icon-pro icon-communication-125',
				'u-line-icon-pro icon-communication-126',
				'u-line-icon-pro icon-communication-139',
				'u-line-icon-pro icon-communication-152',
				'u-line-icon-pro icon-communication-165',
				'u-line-icon-pro icon-communication-178',
				'u-line-icon-pro icon-communication-179',
				'u-line-icon-pro icon-communication-166',
				'u-line-icon-pro icon-communication-153',
				'u-line-icon-pro icon-communication-140',
				'u-line-icon-pro icon-communication-127',
				'u-line-icon-pro icon-communication-128',
				'u-line-icon-pro icon-communication-141',
				'u-line-icon-pro icon-communication-154',
				'u-line-icon-pro icon-communication-167',
				'u-line-icon-pro icon-communication-180',
				'u-line-icon-pro icon-communication-168',
				'u-line-icon-pro icon-communication-169',
				'u-line-icon-pro icon-communication-156',
				'u-line-icon-pro icon-communication-155',
				'u-line-icon-pro icon-communication-142',
				'u-line-icon-pro icon-communication-143',
				'u-line-icon-pro icon-communication-130',
				'u-line-icon-pro icon-communication-129',
			],
		},
		{
			id: 'ELECTRONICS',
			name: Loc.getMessage('LANDING_ICONS_SECTION_ELECTRONICS'),
			items: [
				'u-line-icon-pro icon-electronics-001',
				'u-line-icon-pro icon-electronics-014',
				'u-line-icon-pro icon-electronics-027',
				'u-line-icon-pro icon-electronics-040',
				'u-line-icon-pro icon-electronics-053',
				'u-line-icon-pro icon-electronics-066',
				'u-line-icon-pro icon-electronics-079',
				'u-line-icon-pro icon-electronics-092',
				'u-line-icon-pro icon-electronics-093',
				'u-line-icon-pro icon-electronics-080',
				'u-line-icon-pro icon-electronics-067',
				'u-line-icon-pro icon-electronics-054',
				'u-line-icon-pro icon-electronics-041',
				'u-line-icon-pro icon-electronics-028',
				'u-line-icon-pro icon-electronics-015',
				'u-line-icon-pro icon-electronics-002',
				'u-line-icon-pro icon-electronics-003',
				'u-line-icon-pro icon-electronics-016',
				'u-line-icon-pro icon-electronics-029',
				'u-line-icon-pro icon-electronics-042',
				'u-line-icon-pro icon-electronics-055',
				'u-line-icon-pro icon-electronics-068',
				'u-line-icon-pro icon-electronics-081',
				'u-line-icon-pro icon-electronics-094',
				'u-line-icon-pro icon-electronics-095',
				'u-line-icon-pro icon-electronics-082',
				'u-line-icon-pro icon-electronics-069',
				'u-line-icon-pro icon-electronics-056',
				'u-line-icon-pro icon-electronics-043',
				'u-line-icon-pro icon-electronics-030',
				'u-line-icon-pro icon-electronics-017',
				'u-line-icon-pro icon-electronics-004',
				'u-line-icon-pro icon-electronics-005',
				'u-line-icon-pro icon-electronics-018',
				'u-line-icon-pro icon-electronics-031',
				'u-line-icon-pro icon-electronics-044',
				'u-line-icon-pro icon-electronics-057',
				'u-line-icon-pro icon-electronics-070',
				'u-line-icon-pro icon-electronics-083',
				'u-line-icon-pro icon-electronics-096',
				'u-line-icon-pro icon-electronics-097',
				'u-line-icon-pro icon-electronics-084',
				'u-line-icon-pro icon-electronics-071',
				'u-line-icon-pro icon-electronics-058',
				'u-line-icon-pro icon-electronics-045',
				'u-line-icon-pro icon-electronics-032',
				'u-line-icon-pro icon-electronics-019',
				'u-line-icon-pro icon-electronics-006',
				'u-line-icon-pro icon-electronics-007',
				'u-line-icon-pro icon-electronics-020',
				'u-line-icon-pro icon-electronics-033',
				'u-line-icon-pro icon-electronics-046',
				'u-line-icon-pro icon-electronics-059',
				'u-line-icon-pro icon-electronics-072',
				'u-line-icon-pro icon-electronics-085',
				'u-line-icon-pro icon-electronics-098',
				'u-line-icon-pro icon-electronics-099',
				'u-line-icon-pro icon-electronics-086',
				'u-line-icon-pro icon-electronics-073',
				'u-line-icon-pro icon-electronics-060',
				'u-line-icon-pro icon-electronics-047',
				'u-line-icon-pro icon-electronics-034',
				'u-line-icon-pro icon-electronics-021',
				'u-line-icon-pro icon-electronics-008',
				'u-line-icon-pro icon-electronics-009',
				'u-line-icon-pro icon-electronics-022',
				'u-line-icon-pro icon-electronics-035',
				'u-line-icon-pro icon-electronics-048',
				'u-line-icon-pro icon-electronics-049',
				'u-line-icon-pro icon-electronics-036',
				'u-line-icon-pro icon-electronics-023',
				'u-line-icon-pro icon-electronics-010',
				'u-line-icon-pro icon-electronics-011',
				'u-line-icon-pro icon-electronics-024',
				'u-line-icon-pro icon-electronics-025',
				'u-line-icon-pro icon-electronics-012',
				'u-line-icon-pro icon-electronics-013',
				'u-line-icon-pro icon-electronics-026',
				'u-line-icon-pro icon-electronics-039',
				'u-line-icon-pro icon-electronics-052',
				'u-line-icon-pro icon-electronics-065',
				'u-line-icon-pro icon-electronics-078',
				'u-line-icon-pro icon-electronics-091',
				'u-line-icon-pro icon-electronics-104',
				'u-line-icon-pro icon-electronics-103',
				'u-line-icon-pro icon-electronics-090',
				'u-line-icon-pro icon-electronics-064',
				'u-line-icon-pro icon-electronics-051',
				'u-line-icon-pro icon-electronics-038',
				'u-line-icon-pro icon-electronics-037',
				'u-line-icon-pro icon-electronics-050',
				'u-line-icon-pro icon-electronics-063',
				'u-line-icon-pro icon-electronics-076',
				'u-line-icon-pro icon-electronics-077',
				'u-line-icon-pro icon-electronics-062',
				'u-line-icon-pro icon-electronics-061',
				'u-line-icon-pro icon-electronics-074',
				'u-line-icon-pro icon-electronics-075',
				'u-line-icon-pro icon-electronics-088',
				'u-line-icon-pro icon-electronics-087',
				'u-line-icon-pro icon-electronics-089',
				'u-line-icon-pro icon-electronics-102',
				'u-line-icon-pro icon-electronics-101',
				'u-line-icon-pro icon-electronics-100',
				'u-line-icon-pro icon-electronics-105',
				'u-line-icon-pro icon-electronics-118',
				'u-line-icon-pro icon-electronics-131',
				'u-line-icon-pro icon-electronics-144',
				'u-line-icon-pro icon-electronics-157',
				'u-line-icon-pro icon-electronics-158',
				'u-line-icon-pro icon-electronics-145',
				'u-line-icon-pro icon-electronics-132',
				'u-line-icon-pro icon-electronics-119',
				'u-line-icon-pro icon-electronics-106',
				'u-line-icon-pro icon-electronics-107',
				'u-line-icon-pro icon-electronics-120',
				'u-line-icon-pro icon-electronics-133',
				'u-line-icon-pro icon-electronics-146',
				'u-line-icon-pro icon-electronics-159',
				'u-line-icon-pro icon-electronics-160',
				'u-line-icon-pro icon-electronics-147',
				'u-line-icon-pro icon-electronics-134',
				'u-line-icon-pro icon-electronics-121',
				'u-line-icon-pro icon-electronics-108',
				'u-line-icon-pro icon-electronics-109',
				'u-line-icon-pro icon-electronics-122',
				'u-line-icon-pro icon-electronics-135',
				'u-line-icon-pro icon-electronics-148',
				'u-line-icon-pro icon-electronics-149',
				'u-line-icon-pro icon-electronics-136',
				'u-line-icon-pro icon-electronics-123',
				'u-line-icon-pro icon-electronics-110',
				'u-line-icon-pro icon-electronics-111',
				'u-line-icon-pro icon-electronics-124',
				'u-line-icon-pro icon-electronics-137',
				'u-line-icon-pro icon-electronics-150',
				'u-line-icon-pro icon-electronics-151',
				'u-line-icon-pro icon-electronics-138',
				'u-line-icon-pro icon-electronics-125',
				'u-line-icon-pro icon-electronics-112',
				'u-line-icon-pro icon-electronics-113',
				'u-line-icon-pro icon-electronics-126',
				'u-line-icon-pro icon-electronics-139',
				'u-line-icon-pro icon-electronics-152',
				'u-line-icon-pro icon-electronics-153',
				'u-line-icon-pro icon-electronics-140',
				'u-line-icon-pro icon-electronics-127',
				'u-line-icon-pro icon-electronics-114',
				'u-line-icon-pro icon-electronics-115',
				'u-line-icon-pro icon-electronics-128',
				'u-line-icon-pro icon-electronics-141',
				'u-line-icon-pro icon-electronics-154',
				'u-line-icon-pro icon-electronics-155',
				'u-line-icon-pro icon-electronics-142',
				'u-line-icon-pro icon-electronics-129',
				'u-line-icon-pro icon-electronics-116',
				'u-line-icon-pro icon-electronics-117',
				'u-line-icon-pro icon-electronics-130',
				'u-line-icon-pro icon-electronics-143',
				'u-line-icon-pro icon-electronics-156',
			],
		},
		{
			id: 'FURNITURE',
			name: Loc.getMessage('LANDING_ICONS_SECTION_FURNITURE'),
			items: [
				'u-line-icon-pro icon-furniture-001',
				'u-line-icon-pro icon-furniture-014',
				'u-line-icon-pro icon-furniture-027',
				'u-line-icon-pro icon-furniture-040',
				'u-line-icon-pro icon-furniture-041',
				'u-line-icon-pro icon-furniture-028',
				'u-line-icon-pro icon-furniture-015',
				'u-line-icon-pro icon-furniture-002',
				'u-line-icon-pro icon-furniture-003',
				'u-line-icon-pro icon-furniture-016',
				'u-line-icon-pro icon-furniture-029',
				'u-line-icon-pro icon-furniture-042',
				'u-line-icon-pro icon-furniture-043',
				'u-line-icon-pro icon-furniture-030',
				'u-line-icon-pro icon-furniture-017',
				'u-line-icon-pro icon-furniture-004',
				'u-line-icon-pro icon-furniture-005',
				'u-line-icon-pro icon-furniture-018',
				'u-line-icon-pro icon-furniture-031',
				'u-line-icon-pro icon-furniture-044',
				'u-line-icon-pro icon-furniture-045',
				'u-line-icon-pro icon-furniture-032',
				'u-line-icon-pro icon-furniture-019',
				'u-line-icon-pro icon-furniture-006',
				'u-line-icon-pro icon-furniture-007',
				'u-line-icon-pro icon-furniture-020',
				'u-line-icon-pro icon-furniture-033',
				'u-line-icon-pro icon-furniture-046',
				'u-line-icon-pro icon-furniture-047',
				'u-line-icon-pro icon-furniture-034',
				'u-line-icon-pro icon-furniture-021',
				'u-line-icon-pro icon-furniture-008',
				'u-line-icon-pro icon-furniture-009',
				'u-line-icon-pro icon-furniture-022',
				'u-line-icon-pro icon-furniture-035',
				'u-line-icon-pro icon-furniture-048',
				'u-line-icon-pro icon-furniture-049',
				'u-line-icon-pro icon-furniture-036',
				'u-line-icon-pro icon-furniture-023',
				'u-line-icon-pro icon-furniture-010',
				'u-line-icon-pro icon-furniture-011',
				'u-line-icon-pro icon-furniture-024',
				'u-line-icon-pro icon-furniture-037',
				'u-line-icon-pro icon-furniture-050',
				'u-line-icon-pro icon-furniture-051',
				'u-line-icon-pro icon-furniture-038',
				'u-line-icon-pro icon-furniture-025',
				'u-line-icon-pro icon-furniture-012',
				'u-line-icon-pro icon-furniture-013',
				'u-line-icon-pro icon-furniture-026',
				'u-line-icon-pro icon-furniture-039',
				'u-line-icon-pro icon-furniture-052',
				'u-line-icon-pro icon-furniture-065',
				'u-line-icon-pro icon-furniture-064',
				'u-line-icon-pro icon-furniture-063',
				'u-line-icon-pro icon-furniture-062',
				'u-line-icon-pro icon-furniture-061',
				'u-line-icon-pro icon-furniture-060',
				'u-line-icon-pro icon-furniture-059',
				'u-line-icon-pro icon-furniture-058',
				'u-line-icon-pro icon-furniture-057',
				'u-line-icon-pro icon-furniture-056',
				'u-line-icon-pro icon-furniture-055',
				'u-line-icon-pro icon-furniture-054',
				'u-line-icon-pro icon-furniture-053',
				'u-line-icon-pro icon-furniture-066',
				'u-line-icon-pro icon-furniture-079',
				'u-line-icon-pro icon-furniture-092',
				'u-line-icon-pro icon-furniture-093',
				'u-line-icon-pro icon-furniture-080',
				'u-line-icon-pro icon-furniture-067',
				'u-line-icon-pro icon-furniture-068',
				'u-line-icon-pro icon-furniture-081',
				'u-line-icon-pro icon-furniture-094',
				'u-line-icon-pro icon-furniture-095',
				'u-line-icon-pro icon-furniture-082',
				'u-line-icon-pro icon-furniture-069',
				'u-line-icon-pro icon-furniture-070',
				'u-line-icon-pro icon-furniture-083',
				'u-line-icon-pro icon-furniture-096',
				'u-line-icon-pro icon-furniture-097',
				'u-line-icon-pro icon-furniture-084',
				'u-line-icon-pro icon-furniture-071',
				'u-line-icon-pro icon-furniture-073',
				'u-line-icon-pro icon-furniture-072',
				'u-line-icon-pro icon-furniture-085',
				'u-line-icon-pro icon-furniture-098',
				'u-line-icon-pro icon-furniture-099',
				'u-line-icon-pro icon-furniture-086',
				'u-line-icon-pro icon-furniture-087',
				'u-line-icon-pro icon-furniture-100',
				'u-line-icon-pro icon-furniture-075',
				'u-line-icon-pro icon-furniture-074',
				'u-line-icon-pro icon-furniture-076',
				'u-line-icon-pro icon-furniture-089',
				'u-line-icon-pro icon-furniture-088',
				'u-line-icon-pro icon-furniture-090',
				'u-line-icon-pro icon-furniture-077',
				'u-line-icon-pro icon-furniture-078',
				'u-line-icon-pro icon-furniture-091',
			],
		},
		{
			id: 'MEDIA',
			name: Loc.getMessage('LANDING_ICONS_SECTION_PLAYER'),
			items: [
				'u-line-icon-pro icon-media-001',
				'u-line-icon-pro icon-media-014',
				'u-line-icon-pro icon-media-027',
				'u-line-icon-pro icon-media-040',
				'u-line-icon-pro icon-media-041',
				'u-line-icon-pro icon-media-028',
				'u-line-icon-pro icon-media-015',
				'u-line-icon-pro icon-media-002',
				'u-line-icon-pro icon-media-003',
				'u-line-icon-pro icon-media-016',
				'u-line-icon-pro icon-media-029',
				'u-line-icon-pro icon-media-042',
				'u-line-icon-pro icon-media-043',
				'u-line-icon-pro icon-media-030',
				'u-line-icon-pro icon-media-017',
				'u-line-icon-pro icon-media-004',
				'u-line-icon-pro icon-media-005',
				'u-line-icon-pro icon-media-018',
				'u-line-icon-pro icon-media-031',
				'u-line-icon-pro icon-media-044',
				'u-line-icon-pro icon-media-045',
				'u-line-icon-pro icon-media-032',
				'u-line-icon-pro icon-media-019',
				'u-line-icon-pro icon-media-006',
				'u-line-icon-pro icon-media-007',
				'u-line-icon-pro icon-media-020',
				'u-line-icon-pro icon-media-033',
				'u-line-icon-pro icon-media-046',
				'u-line-icon-pro icon-media-047',
				'u-line-icon-pro icon-media-034',
				'u-line-icon-pro icon-media-021',
				'u-line-icon-pro icon-media-008',
				'u-line-icon-pro icon-media-009',
				'u-line-icon-pro icon-media-022',
				'u-line-icon-pro icon-media-035',
				'u-line-icon-pro icon-media-048',
				'u-line-icon-pro icon-media-049',
				'u-line-icon-pro icon-media-036',
				'u-line-icon-pro icon-media-023',
				'u-line-icon-pro icon-media-010',
				'u-line-icon-pro icon-media-011',
				'u-line-icon-pro icon-media-024',
				'u-line-icon-pro icon-media-037',
				'u-line-icon-pro icon-media-050',
				'u-line-icon-pro icon-media-063',
				'u-line-icon-pro icon-media-064',
				'u-line-icon-pro icon-media-051',
				'u-line-icon-pro icon-media-038',
				'u-line-icon-pro icon-media-025',
				'u-line-icon-pro icon-media-012',
				'u-line-icon-pro icon-media-013',
				'u-line-icon-pro icon-media-026',
				'u-line-icon-pro icon-media-039',
				'u-line-icon-pro icon-media-052',
				'u-line-icon-pro icon-media-065',
				'u-line-icon-pro icon-media-062',
				'u-line-icon-pro icon-media-061',
				'u-line-icon-pro icon-media-060',
				'u-line-icon-pro icon-media-059',
				'u-line-icon-pro icon-media-058',
				'u-line-icon-pro icon-media-057',
				'u-line-icon-pro icon-media-056',
				'u-line-icon-pro icon-media-055',
				'u-line-icon-pro icon-media-054',
				'u-line-icon-pro icon-media-053',
				'u-line-icon-pro icon-media-066',
				'u-line-icon-pro icon-media-079',
				'u-line-icon-pro icon-media-092',
				'u-line-icon-pro icon-media-105',
				'u-line-icon-pro icon-media-118',
				'u-line-icon-pro icon-media-119',
				'u-line-icon-pro icon-media-106',
				'u-line-icon-pro icon-media-093',
				'u-line-icon-pro icon-media-080',
				'u-line-icon-pro icon-media-067',
				'u-line-icon-pro icon-media-068',
				'u-line-icon-pro icon-media-081',
				'u-line-icon-pro icon-media-094',
				'u-line-icon-pro icon-media-107',
				'u-line-icon-pro icon-media-120',
				'u-line-icon-pro icon-media-121',
				'u-line-icon-pro icon-media-108',
				'u-line-icon-pro icon-media-095',
				'u-line-icon-pro icon-media-082',
				'u-line-icon-pro icon-media-069',
				'u-line-icon-pro icon-media-070',
				'u-line-icon-pro icon-media-083',
				'u-line-icon-pro icon-media-096',
				'u-line-icon-pro icon-media-109',
				'u-line-icon-pro icon-media-122',
				'u-line-icon-pro icon-media-123',
				'u-line-icon-pro icon-media-110',
				'u-line-icon-pro icon-media-097',
				'u-line-icon-pro icon-media-084',
				'u-line-icon-pro icon-media-071',
				'u-line-icon-pro icon-media-072',
				'u-line-icon-pro icon-media-085',
				'u-line-icon-pro icon-media-098',
				'u-line-icon-pro icon-media-111',
				'u-line-icon-pro icon-media-124',
				'u-line-icon-pro icon-media-125',
				'u-line-icon-pro icon-media-112',
				'u-line-icon-pro icon-media-099',
				'u-line-icon-pro icon-media-086',
				'u-line-icon-pro icon-media-073',
				'u-line-icon-pro icon-media-074',
				'u-line-icon-pro icon-media-087',
				'u-line-icon-pro icon-media-100',
				'u-line-icon-pro icon-media-113',
				'u-line-icon-pro icon-media-126',
				'u-line-icon-pro icon-media-127',
				'u-line-icon-pro icon-media-114',
				'u-line-icon-pro icon-media-101',
				'u-line-icon-pro icon-media-088',
				'u-line-icon-pro icon-media-075',
				'u-line-icon-pro icon-media-076',
				'u-line-icon-pro icon-media-089',
				'u-line-icon-pro icon-media-090',
				'u-line-icon-pro icon-media-077',
				'u-line-icon-pro icon-media-078',
				'u-line-icon-pro icon-media-091',
				'u-line-icon-pro icon-media-104',
				'u-line-icon-pro icon-media-103',
				'u-line-icon-pro icon-media-102',
				'u-line-icon-pro icon-media-115',
				'u-line-icon-pro icon-media-116',
				'u-line-icon-pro icon-media-117',
				'u-line-icon-pro icon-media-130',
				'u-line-icon-pro icon-media-129',
				'u-line-icon-pro icon-media-128',
			],
		},
		{
			id: 'MUSIC',
			name: Loc.getMessage('LANDING_ICONS_SECTION_MUSIC'),
			items: [
				'u-line-icon-pro icon-music-001',
				'u-line-icon-pro icon-music-014',
				'u-line-icon-pro icon-music-027',
				'u-line-icon-pro icon-music-040',
				'u-line-icon-pro icon-music-053',
				'u-line-icon-pro icon-music-054',
				'u-line-icon-pro icon-music-041',
				'u-line-icon-pro icon-music-028',
				'u-line-icon-pro icon-music-015',
				'u-line-icon-pro icon-music-002',
				'u-line-icon-pro icon-music-003',
				'u-line-icon-pro icon-music-016',
				'u-line-icon-pro icon-music-029',
				'u-line-icon-pro icon-music-042',
				'u-line-icon-pro icon-music-055',
				'u-line-icon-pro icon-music-056',
				'u-line-icon-pro icon-music-043',
				'u-line-icon-pro icon-music-030',
				'u-line-icon-pro icon-music-017',
				'u-line-icon-pro icon-music-004',
				'u-line-icon-pro icon-music-005',
				'u-line-icon-pro icon-music-018',
				'u-line-icon-pro icon-music-031',
				'u-line-icon-pro icon-music-044',
				'u-line-icon-pro icon-music-057',
				'u-line-icon-pro icon-music-058',
				'u-line-icon-pro icon-music-045',
				'u-line-icon-pro icon-music-032',
				'u-line-icon-pro icon-music-019',
				'u-line-icon-pro icon-music-006',
				'u-line-icon-pro icon-music-007',
				'u-line-icon-pro icon-music-020',
				'u-line-icon-pro icon-music-033',
				'u-line-icon-pro icon-music-046',
				'u-line-icon-pro icon-music-059',
				'u-line-icon-pro icon-music-060',
				'u-line-icon-pro icon-music-047',
				'u-line-icon-pro icon-music-034',
				'u-line-icon-pro icon-music-021',
				'u-line-icon-pro icon-music-008',
				'u-line-icon-pro icon-music-009',
				'u-line-icon-pro icon-music-022',
				'u-line-icon-pro icon-music-035',
				'u-line-icon-pro icon-music-048',
				'u-line-icon-pro icon-music-061',
				'u-line-icon-pro icon-music-062',
				'u-line-icon-pro icon-music-036',
				'u-line-icon-pro icon-music-023',
				'u-line-icon-pro icon-music-010',
				'u-line-icon-pro icon-music-011',
				'u-line-icon-pro icon-music-024',
				'u-line-icon-pro icon-music-037',
				'u-line-icon-pro icon-music-049',
				'u-line-icon-pro icon-music-050',
				'u-line-icon-pro icon-music-051',
				'u-line-icon-pro icon-music-038',
				'u-line-icon-pro icon-music-025',
				'u-line-icon-pro icon-music-012',
				'u-line-icon-pro icon-music-013',
				'u-line-icon-pro icon-music-026',
				'u-line-icon-pro icon-music-039',
				'u-line-icon-pro icon-music-052',
				'u-line-icon-pro icon-music-065',
				'u-line-icon-pro icon-music-064',
				'u-line-icon-pro icon-music-063',
				'u-line-icon-pro icon-music-078',
				'u-line-icon-pro icon-music-091',
				'u-line-icon-pro icon-music-090',
				'u-line-icon-pro icon-music-077',
				'u-line-icon-pro icon-music-076',
				'u-line-icon-pro icon-music-089',
				'u-line-icon-pro icon-music-088',
				'u-line-icon-pro icon-music-075',
				'u-line-icon-pro icon-music-074',
				'u-line-icon-pro icon-music-087',
				'u-line-icon-pro icon-music-086',
				'u-line-icon-pro icon-music-073',
				'u-line-icon-pro icon-music-072',
				'u-line-icon-pro icon-music-085',
				'u-line-icon-pro icon-music-084',
				'u-line-icon-pro icon-music-071',
				'u-line-icon-pro icon-music-070',
				'u-line-icon-pro icon-music-083',
				'u-line-icon-pro icon-music-082',
				'u-line-icon-pro icon-music-069',
				'u-line-icon-pro icon-music-068',
				'u-line-icon-pro icon-music-081',
				'u-line-icon-pro icon-music-080',
				'u-line-icon-pro icon-music-067',
				'u-line-icon-pro icon-music-066',
				'u-line-icon-pro icon-music-079',
				'u-line-icon-pro icon-music-092',
				'u-line-icon-pro icon-music-093',
				'u-line-icon-pro icon-music-094',
				'u-line-icon-pro icon-music-095',
				'u-line-icon-pro icon-music-096',
				'u-line-icon-pro icon-music-097',
				'u-line-icon-pro icon-music-098',
				'u-line-icon-pro icon-music-099',
				'u-line-icon-pro icon-music-100',
			],
		},
		{
			id: 'SCIENCE',
			name: Loc.getMessage('LANDING_ICONS_SECTION_SCIENCE'),
			items: [
				'u-line-icon-pro icon-science-001',
				'u-line-icon-pro icon-science-014',
				'u-line-icon-pro icon-science-002',
				'u-line-icon-pro icon-science-015',
				'u-line-icon-pro icon-science-016',
				'u-line-icon-pro icon-science-003',
				'u-line-icon-pro icon-science-004',
				'u-line-icon-pro icon-science-017',
				'u-line-icon-pro icon-science-019',
				'u-line-icon-pro icon-science-005',
				'u-line-icon-pro icon-science-018',
				'u-line-icon-pro icon-science-006',
				'u-line-icon-pro icon-science-007',
				'u-line-icon-pro icon-science-020',
				'u-line-icon-pro icon-science-021',
				'u-line-icon-pro icon-science-008',
				'u-line-icon-pro icon-science-009',
				'u-line-icon-pro icon-science-022',
				'u-line-icon-pro icon-science-023',
				'u-line-icon-pro icon-science-010',
				'u-line-icon-pro icon-science-011',
				'u-line-icon-pro icon-science-024',
				'u-line-icon-pro icon-science-025',
				'u-line-icon-pro icon-science-012',
				'u-line-icon-pro icon-science-013',
				'u-line-icon-pro icon-science-026',
				'u-line-icon-pro icon-science-039',
				'u-line-icon-pro icon-science-052',
				'u-line-icon-pro icon-science-065',
				'u-line-icon-pro icon-science-078',
				'u-line-icon-pro icon-science-077',
				'u-line-icon-pro icon-science-064',
				'u-line-icon-pro icon-science-051',
				'u-line-icon-pro icon-science-038',
				'u-line-icon-pro icon-science-037',
				'u-line-icon-pro icon-science-050',
				'u-line-icon-pro icon-science-063',
				'u-line-icon-pro icon-science-076',
				'u-line-icon-pro icon-science-075',
				'u-line-icon-pro icon-science-062',
				'u-line-icon-pro icon-science-049',
				'u-line-icon-pro icon-science-036',
				'u-line-icon-pro icon-science-035',
				'u-line-icon-pro icon-science-048',
				'u-line-icon-pro icon-science-061',
				'u-line-icon-pro icon-science-074',
				'u-line-icon-pro icon-science-073',
				'u-line-icon-pro icon-science-060',
				'u-line-icon-pro icon-science-047',
				'u-line-icon-pro icon-science-034',
				'u-line-icon-pro icon-science-033',
				'u-line-icon-pro icon-science-046',
				'u-line-icon-pro icon-science-059',
				'u-line-icon-pro icon-science-072',
				'u-line-icon-pro icon-science-071',
				'u-line-icon-pro icon-science-058',
				'u-line-icon-pro icon-science-045',
				'u-line-icon-pro icon-science-032',
				'u-line-icon-pro icon-science-031',
				'u-line-icon-pro icon-science-044',
				'u-line-icon-pro icon-science-057',
				'u-line-icon-pro icon-science-070',
				'u-line-icon-pro icon-science-069',
				'u-line-icon-pro icon-science-056',
				'u-line-icon-pro icon-science-043',
				'u-line-icon-pro icon-science-030',
				'u-line-icon-pro icon-science-029',
				'u-line-icon-pro icon-science-042',
				'u-line-icon-pro icon-science-055',
				'u-line-icon-pro icon-science-068',
				'u-line-icon-pro icon-science-067',
				'u-line-icon-pro icon-science-054',
				'u-line-icon-pro icon-science-041',
				'u-line-icon-pro icon-science-028',
				'u-line-icon-pro icon-science-027',
				'u-line-icon-pro icon-science-040',
				'u-line-icon-pro icon-science-053',
				'u-line-icon-pro icon-science-066',
				'u-line-icon-pro icon-science-079',
				'u-line-icon-pro icon-science-092',
				'u-line-icon-pro icon-science-105',
				'u-line-icon-pro icon-science-118',
				'u-line-icon-pro icon-science-131',
				'u-line-icon-pro icon-science-144',
				'u-line-icon-pro icon-science-145',
				'u-line-icon-pro icon-science-132',
				'u-line-icon-pro icon-science-119',
				'u-line-icon-pro icon-science-106',
				'u-line-icon-pro icon-science-093',
				'u-line-icon-pro icon-science-080',
				'u-line-icon-pro icon-science-081',
				'u-line-icon-pro icon-science-094',
				'u-line-icon-pro icon-science-107',
				'u-line-icon-pro icon-science-120',
				'u-line-icon-pro icon-science-133',
				'u-line-icon-pro icon-science-146',
				'u-line-icon-pro icon-science-147',
				'u-line-icon-pro icon-science-134',
				'u-line-icon-pro icon-science-121',
				'u-line-icon-pro icon-science-108',
				'u-line-icon-pro icon-science-095',
				'u-line-icon-pro icon-science-082',
				'u-line-icon-pro icon-science-083',
				'u-line-icon-pro icon-science-096',
				'u-line-icon-pro icon-science-109',
				'u-line-icon-pro icon-science-122',
				'u-line-icon-pro icon-science-135',
				'u-line-icon-pro icon-science-148',
				'u-line-icon-pro icon-science-149',
				'u-line-icon-pro icon-science-136',
				'u-line-icon-pro icon-science-123',
				'u-line-icon-pro icon-science-110',
				'u-line-icon-pro icon-science-097',
				'u-line-icon-pro icon-science-084',
				'u-line-icon-pro icon-science-085',
				'u-line-icon-pro icon-science-098',
				'u-line-icon-pro icon-science-111',
				'u-line-icon-pro icon-science-124',
				'u-line-icon-pro icon-science-137',
				'u-line-icon-pro icon-science-150',
				'u-line-icon-pro icon-science-151',
				'u-line-icon-pro icon-science-138',
				'u-line-icon-pro icon-science-125',
				'u-line-icon-pro icon-science-112',
				'u-line-icon-pro icon-science-099',
				'u-line-icon-pro icon-science-086',
				'u-line-icon-pro icon-science-087',
				'u-line-icon-pro icon-science-100',
				'u-line-icon-pro icon-science-113',
				'u-line-icon-pro icon-science-126',
				'u-line-icon-pro icon-science-139',
				'u-line-icon-pro icon-science-152',
				'u-line-icon-pro icon-science-153',
				'u-line-icon-pro icon-science-140',
				'u-line-icon-pro icon-science-127',
				'u-line-icon-pro icon-science-114',
				'u-line-icon-pro icon-science-101',
				'u-line-icon-pro icon-science-088',
				'u-line-icon-pro icon-science-089',
				'u-line-icon-pro icon-science-102',
				'u-line-icon-pro icon-science-115',
				'u-line-icon-pro icon-science-128',
				'u-line-icon-pro icon-science-141',
				'u-line-icon-pro icon-science-154',
				'u-line-icon-pro icon-science-155',
				'u-line-icon-pro icon-science-142',
				'u-line-icon-pro icon-science-129',
				'u-line-icon-pro icon-science-116',
				'u-line-icon-pro icon-science-103',
				'u-line-icon-pro icon-science-090',
				'u-line-icon-pro icon-science-091',
				'u-line-icon-pro icon-science-104',
				'u-line-icon-pro icon-science-117',
				'u-line-icon-pro icon-science-130',
				'u-line-icon-pro icon-science-143',
				'u-line-icon-pro icon-science-156',
				'u-line-icon-pro icon-science-157',
				'u-line-icon-pro icon-science-158',
				'u-line-icon-pro icon-science-159',
				'u-line-icon-pro icon-science-160',
			],
		},
		{
			id: 'SPORTS',
			name: Loc.getMessage('LANDING_ICONS_SECTION_SPORTS'),
			items: [
				'u-line-icon-pro icon-sport-001',
				'u-line-icon-pro icon-sport-014',
				'u-line-icon-pro icon-sport-027',
				'u-line-icon-pro icon-sport-028',
				'u-line-icon-pro icon-sport-015',
				'u-line-icon-pro icon-sport-002',
				'u-line-icon-pro icon-sport-003',
				'u-line-icon-pro icon-sport-016',
				'u-line-icon-pro icon-sport-029',
				'u-line-icon-pro icon-sport-030',
				'u-line-icon-pro icon-sport-017',
				'u-line-icon-pro icon-sport-004',
				'u-line-icon-pro icon-sport-005',
				'u-line-icon-pro icon-sport-018',
				'u-line-icon-pro icon-sport-031',
				'u-line-icon-pro icon-sport-032',
				'u-line-icon-pro icon-sport-019',
				'u-line-icon-pro icon-sport-006',
				'u-line-icon-pro icon-sport-007',
				'u-line-icon-pro icon-sport-020',
				'u-line-icon-pro icon-sport-033',
				'u-line-icon-pro icon-sport-034',
				'u-line-icon-pro icon-sport-021',
				'u-line-icon-pro icon-sport-008',
				'u-line-icon-pro icon-sport-009',
				'u-line-icon-pro icon-sport-022',
				'u-line-icon-pro icon-sport-035',
				'u-line-icon-pro icon-sport-036',
				'u-line-icon-pro icon-sport-023',
				'u-line-icon-pro icon-sport-010',
				'u-line-icon-pro icon-sport-011',
				'u-line-icon-pro icon-sport-024',
				'u-line-icon-pro icon-sport-037',
				'u-line-icon-pro icon-sport-038',
				'u-line-icon-pro icon-sport-025',
				'u-line-icon-pro icon-sport-012',
				'u-line-icon-pro icon-sport-013',
				'u-line-icon-pro icon-sport-026',
				'u-line-icon-pro icon-sport-039',
				'u-line-icon-pro icon-sport-040',
				'u-line-icon-pro icon-sport-053',
				'u-line-icon-pro icon-sport-066',
				'u-line-icon-pro icon-sport-079',
				'u-line-icon-pro icon-sport-080',
				'u-line-icon-pro icon-sport-067',
				'u-line-icon-pro icon-sport-054',
				'u-line-icon-pro icon-sport-041',
				'u-line-icon-pro icon-sport-042',
				'u-line-icon-pro icon-sport-055',
				'u-line-icon-pro icon-sport-068',
				'u-line-icon-pro icon-sport-081',
				'u-line-icon-pro icon-sport-082',
				'u-line-icon-pro icon-sport-069',
				'u-line-icon-pro icon-sport-056',
				'u-line-icon-pro icon-sport-043',
				'u-line-icon-pro icon-sport-044',
				'u-line-icon-pro icon-sport-057',
				'u-line-icon-pro icon-sport-070',
				'u-line-icon-pro icon-sport-083',
				'u-line-icon-pro icon-sport-084',
				'u-line-icon-pro icon-sport-071',
				'u-line-icon-pro icon-sport-058',
				'u-line-icon-pro icon-sport-045',
				'u-line-icon-pro icon-sport-046',
				'u-line-icon-pro icon-sport-059',
				'u-line-icon-pro icon-sport-072',
				'u-line-icon-pro icon-sport-085',
				'u-line-icon-pro icon-sport-086',
				'u-line-icon-pro icon-sport-073',
				'u-line-icon-pro icon-sport-060',
				'u-line-icon-pro icon-sport-047',
				'u-line-icon-pro icon-sport-048',
				'u-line-icon-pro icon-sport-061',
				'u-line-icon-pro icon-sport-074',
				'u-line-icon-pro icon-sport-087',
				'u-line-icon-pro icon-sport-075',
				'u-line-icon-pro icon-sport-062',
				'u-line-icon-pro icon-sport-049',
				'u-line-icon-pro icon-sport-050',
				'u-line-icon-pro icon-sport-063',
				'u-line-icon-pro icon-sport-064',
				'u-line-icon-pro icon-sport-051',
				'u-line-icon-pro icon-sport-052',
				'u-line-icon-pro icon-sport-065',
				'u-line-icon-pro icon-sport-078',
				'u-line-icon-pro icon-sport-091',
				'u-line-icon-pro icon-sport-090',
				'u-line-icon-pro icon-sport-077',
				'u-line-icon-pro icon-sport-076',
				'u-line-icon-pro icon-sport-089',
				'u-line-icon-pro icon-sport-088',
				'u-line-icon-pro icon-sport-092',
				'u-line-icon-pro icon-sport-105',
				'u-line-icon-pro icon-sport-118',
				'u-line-icon-pro icon-sport-131',
				'u-line-icon-pro icon-sport-144',
				'u-line-icon-pro icon-sport-145',
				'u-line-icon-pro icon-sport-132',
				'u-line-icon-pro icon-sport-119',
				'u-line-icon-pro icon-sport-106',
				'u-line-icon-pro icon-sport-093',
				'u-line-icon-pro icon-sport-094',
				'u-line-icon-pro icon-sport-107',
				'u-line-icon-pro icon-sport-120',
				'u-line-icon-pro icon-sport-133',
				'u-line-icon-pro icon-sport-146',
				'u-line-icon-pro icon-sport-147',
				'u-line-icon-pro icon-sport-134',
				'u-line-icon-pro icon-sport-121',
				'u-line-icon-pro icon-sport-108',
				'u-line-icon-pro icon-sport-095',
				'u-line-icon-pro icon-sport-096',
				'u-line-icon-pro icon-sport-109',
				'u-line-icon-pro icon-sport-122',
				'u-line-icon-pro icon-sport-135',
				'u-line-icon-pro icon-sport-148',
				'u-line-icon-pro icon-sport-149',
				'u-line-icon-pro icon-sport-136',
				'u-line-icon-pro icon-sport-123',
				'u-line-icon-pro icon-sport-110',
				'u-line-icon-pro icon-sport-097',
				'u-line-icon-pro icon-sport-098',
				'u-line-icon-pro icon-sport-111',
				'u-line-icon-pro icon-sport-124',
				'u-line-icon-pro icon-sport-137',
				'u-line-icon-pro icon-sport-150',
				'u-line-icon-pro icon-sport-151',
				'u-line-icon-pro icon-sport-138',
				'u-line-icon-pro icon-sport-125',
				'u-line-icon-pro icon-sport-112',
				'u-line-icon-pro icon-sport-099',
				'u-line-icon-pro icon-sport-100',
				'u-line-icon-pro icon-sport-113',
				'u-line-icon-pro icon-sport-126',
				'u-line-icon-pro icon-sport-139',
				'u-line-icon-pro icon-sport-152',
				'u-line-icon-pro icon-sport-153',
				'u-line-icon-pro icon-sport-140',
				'u-line-icon-pro icon-sport-127',
				'u-line-icon-pro icon-sport-114',
				'u-line-icon-pro icon-sport-101',
				'u-line-icon-pro icon-sport-102',
				'u-line-icon-pro icon-sport-115',
				'u-line-icon-pro icon-sport-128',
				'u-line-icon-pro icon-sport-141',
				'u-line-icon-pro icon-sport-154',
				'u-line-icon-pro icon-sport-155',
				'u-line-icon-pro icon-sport-142',
				'u-line-icon-pro icon-sport-129',
				'u-line-icon-pro icon-sport-116',
				'u-line-icon-pro icon-sport-103',
				'u-line-icon-pro icon-sport-104',
				'u-line-icon-pro icon-sport-117',
				'u-line-icon-pro icon-sport-130',
				'u-line-icon-pro icon-sport-143',
				'u-line-icon-pro icon-sport-156',
				'u-line-icon-pro icon-sport-157',
				'u-line-icon-pro icon-sport-170',
				'u-line-icon-pro icon-sport-183',
				'u-line-icon-pro icon-sport-196',
				'u-line-icon-pro icon-sport-197',
				'u-line-icon-pro icon-sport-184',
				'u-line-icon-pro icon-sport-171',
				'u-line-icon-pro icon-sport-158',
				'u-line-icon-pro icon-sport-159',
				'u-line-icon-pro icon-sport-172',
				'u-line-icon-pro icon-sport-185',
				'u-line-icon-pro icon-sport-198',
				'u-line-icon-pro icon-sport-199',
				'u-line-icon-pro icon-sport-186',
				'u-line-icon-pro icon-sport-173',
				'u-line-icon-pro icon-sport-160',
				'u-line-icon-pro icon-sport-174',
				'u-line-icon-pro icon-sport-187',
				'u-line-icon-pro icon-sport-200',
				'u-line-icon-pro icon-sport-188',
				'u-line-icon-pro icon-sport-175',
				'u-line-icon-pro icon-sport-162',
				'u-line-icon-pro icon-sport-163',
				'u-line-icon-pro icon-sport-176',
				'u-line-icon-pro icon-sport-189',
				'u-line-icon-pro icon-sport-190',
				'u-line-icon-pro icon-sport-177',
				'u-line-icon-pro icon-sport-164',
				'u-line-icon-pro icon-sport-165',
				'u-line-icon-pro icon-sport-178',
				'u-line-icon-pro icon-sport-191',
				'u-line-icon-pro icon-sport-192',
				'u-line-icon-pro icon-sport-179',
				'u-line-icon-pro icon-sport-166',
				'u-line-icon-pro icon-sport-167',
				'u-line-icon-pro icon-sport-180',
				'u-line-icon-pro icon-sport-193',
				'u-line-icon-pro icon-sport-194',
				'u-line-icon-pro icon-sport-181',
				'u-line-icon-pro icon-sport-168',
				'u-line-icon-pro icon-sport-169',
				'u-line-icon-pro icon-sport-182',
				'u-line-icon-pro icon-sport-195',
				'u-line-icon-pro icon-sport-161',
			],
		},
		{
			id: 'WEATHER',
			name: Loc.getMessage('LANDING_ICONS_SECTION_WEATHER'),
			items: [
				'u-line-icon-pro icon-weather-001',
				'u-line-icon-pro icon-weather-014',
				'u-line-icon-pro icon-weather-027',
				'u-line-icon-pro icon-weather-040',
				'u-line-icon-pro icon-weather-053',
				'u-line-icon-pro icon-weather-054',
				'u-line-icon-pro icon-weather-041',
				'u-line-icon-pro icon-weather-028',
				'u-line-icon-pro icon-weather-015',
				'u-line-icon-pro icon-weather-002',
				'u-line-icon-pro icon-weather-003',
				'u-line-icon-pro icon-weather-016',
				'u-line-icon-pro icon-weather-029',
				'u-line-icon-pro icon-weather-042',
				'u-line-icon-pro icon-weather-055',
				'u-line-icon-pro icon-weather-056',
				'u-line-icon-pro icon-weather-043',
				'u-line-icon-pro icon-weather-030',
				'u-line-icon-pro icon-weather-017',
				'u-line-icon-pro icon-weather-004',
				'u-line-icon-pro icon-weather-005',
				'u-line-icon-pro icon-weather-018',
				'u-line-icon-pro icon-weather-031',
				'u-line-icon-pro icon-weather-044',
				'u-line-icon-pro icon-weather-057',
				'u-line-icon-pro icon-weather-058',
				'u-line-icon-pro icon-weather-045',
				'u-line-icon-pro icon-weather-032',
				'u-line-icon-pro icon-weather-019',
				'u-line-icon-pro icon-weather-006',
				'u-line-icon-pro icon-weather-007',
				'u-line-icon-pro icon-weather-020',
				'u-line-icon-pro icon-weather-033',
				'u-line-icon-pro icon-weather-046',
				'u-line-icon-pro icon-weather-059',
				'u-line-icon-pro icon-weather-060',
				'u-line-icon-pro icon-weather-047',
				'u-line-icon-pro icon-weather-034',
				'u-line-icon-pro icon-weather-021',
				'u-line-icon-pro icon-weather-008',
				'u-line-icon-pro icon-weather-009',
				'u-line-icon-pro icon-weather-022',
				'u-line-icon-pro icon-weather-035',
				'u-line-icon-pro icon-weather-048',
				'u-line-icon-pro icon-weather-049',
				'u-line-icon-pro icon-weather-036',
				'u-line-icon-pro icon-weather-023',
				'u-line-icon-pro icon-weather-010',
				'u-line-icon-pro icon-weather-011',
				'u-line-icon-pro icon-weather-024',
				'u-line-icon-pro icon-weather-037',
				'u-line-icon-pro icon-weather-050',
				'u-line-icon-pro icon-weather-051',
				'u-line-icon-pro icon-weather-038',
				'u-line-icon-pro icon-weather-025',
				'u-line-icon-pro icon-weather-012',
				'u-line-icon-pro icon-weather-013',
				'u-line-icon-pro icon-weather-026',
				'u-line-icon-pro icon-weather-039',
				'u-line-icon-pro icon-weather-052',
			],
		},
	],
};